import React from 'react'
import styles from './UIGamePortraitTop.module.scss'
import {UIGameHelpUserSettingsButtonContainer} from '../UIGameHelpButtons/UIGameHelpButtons'
import {UIGameEndReturnToStats} from '../UIGameEnd/UIGameEndReturnToStats/UIGameEndReturnToStats'
import {UIGameTimerContainer} from '../UIGameTimer/UIGameTimerContainer'
import {UIGameEndShareReplay} from '../UIGameEnd/UIGameEndShareReplay/UIGameEndShareReplay'
import {ModeSettingEnum} from '@colonist/types'
import {useIsReplay} from '../../store/selectors/useIsReplay'
import {useGameStore} from '../../store/GameStoreContext'
import clsx from 'clsx'
import {useIsGameEnded} from '../../store/selectors/useIsGameEnded'
import {UIGameBankPortrait} from '../UIGameBankPortrait/UIGameBankPortrait'
import {useBankCardStackSizes} from '../UIGameBank/useBankCardStackSizes'
import {useBankCardState} from '../UIGameBank/useBankCardState'
import {UIGameHelpInformationButton} from '../UIGameHelpButtons/UIGameHelpInformationButton'

interface UIGamePortraitTopProps {
    initialCanResign: boolean
    className?: string
}

export const UIGamePortraitTop = ({
    initialCanResign,
    className,
}: UIGamePortraitTopProps) => {
    const isReplay = useIsReplay()
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)
    const isBeginnerMode = modeSetting === ModeSettingEnum.BeginnerModeClassic4P
    const isGameEnded = useIsGameEnded()
    const bankCardState = useBankCardState()
    const bankCardStackSizes = useBankCardStackSizes()
    const hideBankCards = useGameStore((state) => state.gameState.bankState.hideBankCards)
    const progressCards = useGameStore((state) => state.gameState.mechanicProgressCardsState?.bankProgressCards)

    const isMechanicIslandExplorationActive = useGameStore((state) => state.gameState.mechanicIslandExplorationState) !== undefined
    const victoryPointsToWin = useGameStore((state) => state.gameSettings.victoryPointsToWin)
    const myColor = useGameStore((state) => state.myColor)

    return <div className={clsx(styles.topContainerPortrait, className)}>
        {!isGameEnded && <div className={styles.helpButtonsContainer}>
            <div className={styles.settingsButtonContainer}>
                <UIGameHelpUserSettingsButtonContainer
                    initialCanResign={initialCanResign}
                    isRulesOptionVisible={true} />
            </div>
            <div className={styles.infoButtonContainer}>
                <UIGameHelpInformationButton
                    gameMode={modeSetting}
                    isMechanicIslandExplorationActive={isMechanicIslandExplorationActive}
                    playerColor={myColor}
                    victoryPointsToWin={victoryPointsToWin}/>
            </div>
        </div>}
        {isGameEnded && <div className={styles.gameEndReturnToStatsContainer}>
            <UIGameEndReturnToStats text="strings:game.endGame.cornerButton.openStatsMobile" className={styles.gameEndReturnToStatsButton} />
        </div>}

        <div className={styles.gameBankContainer}>
            <UIGameBankPortrait
                cardState={bankCardState}
                cardStackSizes={bankCardStackSizes}
                hideBankCards={hideBankCards}
                modeSetting={modeSetting}
                progressCards={progressCards}
            />
        </div>
        {isBeginnerMode === false && isGameEnded === false && <div className={styles.gameTimerContainer}>
            <UIGameTimerContainer timerStyle='white' />
        </div>}
        {isReplay && <div className={styles.gameEndShareReplayContainer}>
            <UIGameEndShareReplay />
        </div>}
    </div>
}
